import Vue from 'vue'
window.Vue = Vue
import App from './App'
import navbar from './components/Navbar'
import router from './router'

/* eslint-disable no-new */
new Vue({
  router,
  components: {
    'navbar': navbar
  },
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js